/*
 * @Author: liuyongjun
 * @Date: 2023-11-11 17:37:11
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-05-22 15:09:12
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ca-app/src/utils/common/controller.js
 */
import device from './device'
//用&拼接对象成字符串
const getParams = params => {
  return Object.keys(params)
    .map(key => `${key}=${![undefined, null].includes(params[key]) ? params[key] : ''}`)
    .join('&')
}

const controller = function (path, params = {}, H5Refresh) {
  const query = {
    tittleType: 3, // 默认 tittleType: 3
    ...params
  }
  if (device.isApp || device.webView) {
    const arr = [`${process.env.VUE_APP_PATH}/#/${path}?${getParams(query)}`]
    if (H5Refresh) arr.push({ H5CallBackFunction: 'H5Refresh' })
    this.$native.api.openUrl(arr)
  } else {
    this.$router.push({
      path,
      query
    })
  }
}
export default controller
